import React, { useContext } from 'react'
import '../style/Login.scss'
import mobileCheckout from '../assets/MCO (App Icon at 7MD).png'
import { authClient } from '../common/helper'
import { LanguageContext } from '../context/LanguageContext'
import { useSelector } from 'react-redux'
import Loader from './Loader'

const Login = () =>{
    const { strings } = useContext(LanguageContext)
    const { isLoading } = useSelector(state=>state.languageChange)
    
    if(isLoading) return <Loader languageFetched={!isLoading} />
    
    return (
        <div className="login">
            <div className='login-container'>
                <img src={mobileCheckout} alt={strings.showAndGoText} className='icon' />
                <div >{strings['showAndGoText']}</div>
            </div>              
            <button className="btn" onClick={()=>authClient.authorize()}>{strings.logIn}</button>
        </div>
    )
}
export default Login